<template>
    <div class="c-loader__animation">
        <div class="c-loader__dot"></div>
        <div class="c-loader__dot"></div>
        <div class="c-loader__dot"></div>
        <div class="c-loader__dot"></div>
    </div>
</template>
